<template>
    <div
      class="definition container"
      :style="{ top: definitionPosition + 'px' }"
      v-on-clickaway="() => $emit('closeDefinitionPopup')"
    >
      <div class="close mr-4">
        <i @click="$emit('closeDefinitionPopup')" class="fa fa-times m-3" />
      </div>
      <div class="bg-lilac inner mr-4 ml-4" v-html="definitionContent" />
    </div>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway';

export default {
  directives: {
    onClickaway,
  },

  props: {
    definitionPosition: {
      type: Number,
      required: false,
    },
    definitionContent: {
      type: String,
      required: false,
    },
  },

};
</script>
